import { GET_PAYROLL } from './../constants';
import { handleActions } from "redux-actions"

export const payrolls  = handleActions(
  {
    // [ FETCH_USER ]: (state, action) => action.payload || action.payload.data[0]
    [ GET_PAYROLL ]: (state, action) => action.payload,
  }, {}
)